/* src/app/views/template/components/edit-template-menu/edit-template-spotlight-menu/edit-template-spotlight-menu.component.scss */
/*# sourceMappingURL=edit-template-spotlight-menu.component.css.map */
